module.exports = __webpack_public_path__ + "mu.svg?608811158be096d06089d4c2fd9b6b8d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mu.svg
// module id = 1080
// module chunks = 27